<template>
  <div class="box1">
    <div class="title">数据分析</div>
    <div class="tit">超高课程含金量，致力打造中/高级数据分析师！</div>
    <vue-seamless-scroll
      :data="tabList"
      :class-option="classOption1"
      class="seamless-warp"
    >
      <div class="demo">
        <div class="item" v-for="(item, index) in tabList" :key="index">
          <p>{{ item.tit }}</p>
          <p>{{ item.txt }}</p>
        </div>
      </div>
    </vue-seamless-scroll>
  </div>
</template>

<script>
import vueSeamlessScroll from "vue-seamless-scroll";
export default {
  components: {
    vueSeamlessScroll,
  },
  data() {
    return {
      tabList: [
        { tit: "业务数据分析能力", txt: "满足企业数据驱动运营需求" },
        { tit: "大数据分析能力", txt: "满足企业海量数据分析需求 " },
        { tit: "数据库开发能力", txt: "解决企业数据存储、查询问题" },
        { tit: "数学建模能力", txt: "满足企业数据挖掘需求   " },
        { tit: "服务端搭建能力", txt: "数据分析结果B/S结构呈现" },
        { tit: "BI开发能力", txt: "解决企业数据可视化呈现问题" },
      ],
    };
  },
  computed: {
    classOption1() {
      return {
        step: 0.4, // 数值越大速度滚动越快
        limitMoveNum: 5, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 2, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
      };
    },
  },
};
</script>

<style lang="less" scoped>
.box1 {
  position: relative;
  width: 100%;
  height: 600px;
  background: url("../../../assets/coursePage/dataAnalysis/box1/bgc.png")
    no-repeat;
  background-size: cover;
  background-position: top center;
  padding-top: 56px;
  box-sizing: border-box;

  .title {
    font-size: 84px;
    font-family: PingFangHK-Semibold, PingFangHK;
    font-weight: 600;
    color: #1d2129;
    line-height: 118px;
    letter-spacing: 1px;

    margin-left: 44px;
  }
  .tit {
    font-size: 30px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #1d296d;
    line-height: 42px;
    margin-top: 4px;
    margin-left: 44px;
  }
  .seamless-warp {
    position: absolute;
    width: 100%;
    overflow: hidden;
    bottom: -150px;
    z-index: 10;
    .demo {
      display: flex;
    }
    .item {
      width: 416px;
      height: 184px;
      background: url("../../../assets/coursePage/dataAnalysis/box1/item.png")
        no-repeat;
      padding: 44px 0 36px 48px;
      flex-shrink: 0;
      box-sizing: border-box;
      margin-left: 20px;
      background-size: contain;
      p:nth-child(1) {
        font-size: 28px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #002053;
        line-height: 40px;
      }
      p:nth-child(2) {
        margin-top: 14px;
        font-size: 26px;
        font-size: 24px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #68778f;
        line-height: 34px;
      }
    }
  }
}
</style>
